/**
 * Страница заказов пользователя. Билеты доступны внутри страницы заказа (OrderPage).
 * Поддерживает ?eventId=... для фильтрации по мероприятию.
 */

import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Layout } from "../../components/layout/index.ts";
import { getTelegram } from "../../lib/telegram.ts";
import { OrdersContent } from "./OrdersPage.tsx";

export function OrdersAndTicketsPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const tg = getTelegram();
  const eventIdFromUrl = searchParams.get("eventId");

  useEffect(() => {
    if (!tg) return;
    tg.BackButton.show();
    const handleBack = () => navigate(-1);
    tg.BackButton.onClick(handleBack);
    return () => {
      tg.BackButton.offClick(handleBack);
      tg.BackButton.hide();
    };
  }, [tg, navigate]);

  return (
    <Layout>
      <h1 className="page-title">Заказы и билеты</h1>
      <OrdersContent eventIdFilter={eventIdFromUrl ?? undefined} />
    </Layout>
  );
}
